import React from 'react';
import Modal from './Modal';
import styles from './ModalWindow.css';

/**
 * Window style display of a `<Modal />`
 * Only use this in a new canvas context, not inline
 */
export default function ModalWindow(props) {
  return (
    <div className={styles.base}>
      <Modal {...{ ...props, shadow: false }} />
    </div>
  );
}

ModalWindow.displayName = 'ModalWindow';
